<div class="app-admin-wrap layout-sidebar-large layout-eval-bg">
  <app-header-sidebar></app-header-sidebar>
  <div class="auth-layout-wrap">
    <router-outlet></router-outlet>
  </div>
</div>
